import { darken, lighten, rgba } from 'polished';
import styled from "styled-components";
import { colors } from "../../../utils";

const Wrapper
	= styled.div`
		background-color: ${(props) => props.active ? colors.card.background : colors.inactive};
		cursor: ${(props) => props.active && "pointer"};
		position: relative;
		display: inline-block;
		border-radius: 8px;
		padding: calc(6px + .6vw) 0 calc(6px + .6vw) 0;
		color: white;
		transition: .2s all;
		width: calc(120px + 3vw);

		&:hover {
			box-shadow: ${(props) => props.active && `0px 0px 10px ${rgba(colors.success, .5)}`};
			scale: ${(props) => props.active && '1.01'};
			background-color: ${(props) => props.active ? `${lighten(.02, colors.card.background)}` : colors.inactive};
		}

		.amount {
			background-color: ${(props) => props.active ? colors.success : `${darken(.9, colors.primary)}`};
			color: ${(props) => props.active ? "black" : "rgba(255,255,255,.6)"};
			position: absolute;
			top: calc(6px + .6vw);
			left: calc(6px + .6vw);

			display: flex;
			justify-content: center;
			align-items: center;
			width: calc(10px + 1vw);
			height: calc(10px + 1vw);
			border-radius: 4px;
			font-size: 90%;
			font-weight: 600;
		}

		.traits-img {
			padding: 1px;
			border-radius: 8px;
			background-color: rgba(255,255,255,.3);
			margin: calc(8px + .6vw) auto 0;
			width: calc(100px + 1vw);
			height: calc(100px + 1vw);
			overflow: hidden;

			input[type="image"] {
				width: 100%;
				height: 100%;
				object-fit: contain;

				&:disabled {
					-webkit-filter: grayscale(100%);
					filter: grayscale(100%);
				}
			}
		}

		.name {
			margin-top: calc(6px + .6vw);
			text-align: center;
		}

		.price {
			span {
				color: ${colors.success};
			}
		}

		.scholarz-id {
			font-size: 120%;
			text-align: center;
		}

	`

export default Wrapper
